import { jsx } from "react/jsx-runtime";
import B2BLayout from "../B2BLayout/B2BLayout.esm.js";
import { HEADER_CTAS, FOOTER_COLUMNS, LAYOUT_MENU_ITEMS } from "./constants/layout.esm.js";
import logoSvg from "./constants/logo.svg.esm.js";
const ConstructionLayout = ({
  children,
  submenu,
  header,
  router,
  environment
}) => {
  var _a, _b, _c, _d, _e;
  const logo = {
    src: logoSvg,
    alt: "Zillow New Construction",
    width: 154,
    height: 27,
    link: "https://www.zillow.com/new-construction-advertising/"
  };
  return /* @__PURE__ */ jsx(B2BLayout, { router, env: environment, signInLink: "https://builders.zillowgroup.com/login/", signInRedirectParam: "url", logo, menu: LAYOUT_MENU_ITEMS, subnavItems: (_a = submenu == null ? void 0 : submenu.items) == null ? void 0 : _a.map((item) => ({
    ...item,
    id: parseInt(item.id, 10),
    title: item.title.rendered
  })), subnavPrimaryItem: ((_b = submenu == null ? void 0 : submenu.meta) == null ? void 0 : _b.title) ? {
    title: (_c = submenu == null ? void 0 : submenu.meta) == null ? void 0 : _c.title,
    url: (_d = submenu == null ? void 0 : submenu.meta) == null ? void 0 : _d.url,
    id: 0,
    parent: 0
  } : void 0, searchPrefix: (_e = submenu == null ? void 0 : submenu.meta) == null ? void 0 : _e.search, transparent: header == null ? void 0 : header.transparent, disabled: header == null ? void 0 : header.disabled, footerColumns: FOOTER_COLUMNS, primaryCTALink: HEADER_CTAS.primary.url, primaryCTALabel: HEADER_CTAS.primary.label, secondaryCTALink: HEADER_CTAS.secondary.url, secondaryCTALabel: HEADER_CTAS.secondary.label, sticky: true, children });
};
export {
  ConstructionLayout as default
};
